export default {
  transfer: 'Transfer',
  transferHeadline: 'Run transfer',
  transferSubtitle: 'Create new transaction of requested operation type',
  approve: 'Approve',
  inputDetails: 'Input transfer parameters',
  details: {
    // noModeSelected: 'Select transfer mode '
  },
  selectOperationType: 'Select operation type',
  operationType: 'Operation type',
  amount: 'Amount',
  settlingAccount: "Profile's (settling) account",
  settlingAccountTenant: 'Tenant account',
  settlementAccount: 'Settlement account',
  direction: 'Direction',
  directionOutbound: "Outbound Settlement (from profile's account to settlement account)",
  directionInbound: "Inbound Settlement (from settlement account to profile's account)",
  directionOutboundTenant: 'Outbound Settlement (from tenant account to settlement account)',
  directionInboundTenant: 'Inbound Settlement (from settlement account to tenant account)',
  directionBetween: "Transfer between profile's accounts",
  directionToProfile: "Transfer to profile's account",
  directionFromProfile: "Transfer from profile's account",
  directionBetweenTenant: 'Transfer between tenant accounts',
  directionToTenant: 'Transfer to tenant account',
  directionFromTenant: 'Transfer from tenant account',
  creditAccountNumber: 'Recipient / InLeg Account Number',
  debitAccountNumber: 'Sender / OutLeg Account Number',
  checkConsent: 'Check transfer details',
  account: 'Account',
  sender: 'Sender / OutLeg (Debit)',
  recipient: 'Recipient / InLeg (Credit)',
  senderAmounts: 'Sender / OutLeg amounts (Debit)',
  recipientAmounts: 'Recipient / InLeg amounts (Credit)',
  entry: {
    category: 'Category',
    transactionAmount: 'Transfer amount',
    totalAmount: 'Total amount',
    amount: 'Amount',
  },
  from: 'From',
  to: 'To',
  transferDone: 'Transfer done!',
  comment: 'Note',
  reference: 'Unique reference id',
  operationSubtype: 'Operation subtype',
  exchangeRate: 'FX rate',
  instructedExchangeRate: 'FX rate for instructed amount',
  sameAccountError: 'Sender and recipient accounts must not be the same.',
  result: {
    title: 'Transaction result',
    completed: 'Transaction completed successfully',
    awaitingApproval: 'Transaction is awaiting approval',
    rejected: 'Transaction rejected',
    other: 'Transaction status: %{status}',
    goToTransaction: 'Go to transaction',
    closeDialog: 'Close',
  },
};
